import { render } from "./MainTabs.vue?vue&type=template&id=7b9068da"
import script from "./MainTabs.vue?vue&type=script&lang=ts"
export * from "./MainTabs.vue?vue&type=script&lang=ts"
script.render = render

export default script